const { createAction } = require('redux-actions');

const { MANAGE_CARD_FORM_ERROR } = require('./types');

const cardFormBricksError = createAction(MANAGE_CARD_FORM_ERROR);

module.exports = {
  [MANAGE_CARD_FORM_ERROR]: (status) => (dispatch) => dispatch(cardFormBricksError(status)),
};
